import { ConfirmModalService } from './../../../core/services/confirm-modal.service';
import { ProxyService } from './../../../core/services/proxy.service';
import { Component, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormBuilder, Validators } from '@angular/forms';
import * as _ from 'lodash-es';

import {
  ValidationService,
  AsyncValidatorWExt,
  ModalService,
  AlertService,
  AuthenticationService } from '@core/services';

import { Subscription } from 'rxjs';
import { ExternalSignUpIncompleteFormRequest } from '@shared/models/register-models';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { User } from '@core/redux/stores';
import { TokenType } from '@shared/models/configs/social-auth.configs';

@Component({
  selector: 'app-signin-incomplete',
  templateUrl: './signin-incomplete.component.html',
  styleUrls: ['./signin-incomplete.component.less'],
  providers: [AlertService]
})
export class SigninIncompleteComponent implements OnDestroy {

  public signInIncompleteForm: UntypedFormGroup;
  protected controlName: string;
  public externalUserProfile: ExternalSignUpIncompleteFormRequest;
  protected submitted: boolean;
  private subscriptions = new Subscription();

  constructor(
    public alertService: AlertService,
    private modalService: ModalService,
    private registrationService: AuthenticationService,
    private proxy: ProxyService,
    private confirmModalService: ConfirmModalService) {
    this.submitted = false;
    this.registrationService.setAlertService(this.alertService);
    this.createRegisterForm();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  createRegisterForm() {
    const externalUserParams: any = this.registrationService.extRequest.externalParams;
    this.externalUserProfile = {firstName: externalUserParams.find(a => a.name === 'firstName').value,
    lastName: externalUserParams.find(a => a.name === 'lastName').value, email: externalUserParams.find(a => a.name === 'email').value};
    const formGroup: any = {};
    if (!this.externalUserProfile.firstName) {
      formGroup['firstName'] = new UntypedFormControl({ value: this.externalUserProfile.firstName,
                                    disabled: this.externalUserProfile.firstName},
                                    [Validators.required, ValidationService.firstNameLastNameValidator]);

    }
    if (!this.externalUserProfile.lastName) {
      formGroup['lastName'] = new UntypedFormControl({ value: this.externalUserProfile.lastName,
                                    disabled: this.externalUserProfile.lastName},
                                    [Validators.required, ValidationService.firstNameLastNameValidator]);
    }
    if (!this.externalUserProfile.email) {
      formGroup['email'] = new UntypedFormControl({
                                value: this.externalUserProfile.email, disabled: this.externalUserProfile.email},
                                [Validators.required], [AsyncValidatorWExt.debounce(ValidationService.asyncEmailValidator, 800)]);
    }
    this.signInIncompleteForm = new UntypedFormGroup(formGroup);
  }

  onSubmit() {
    this.submitted = true;
    this.setFormValues();
  }

  setFormValues() {
    if (this.signInIncompleteForm.valid) {
      const formModel = <User>this.signInIncompleteForm.value;
      const externalUser = _.merge(formModel, <User> this.externalUserProfile);
      if (this.registrationService.extRequest.accessTokenType === TokenType.APPLE) {
        externalUser.skipEmailValidation = true;
      }
      this.proxy.httpPost(ApiRoutes.VALIDATE_SIGNUPCUSTOMERS, externalUser).subscribe(
        (success) => {
          this.registrationService.setExternalMissingFields(<ExternalSignUpIncompleteFormRequest>
            { firstName: externalUser.firstName,
              lastName: externalUser.lastName,
              email: externalUser.email });
              this.showModal('app-term-n-condition');
        },
        (err) => {
          // this.loading = false;
          if (err.error && err.error ) {
            if (err.error instanceof Array ) {
              const messg = [];
              err.error.forEach(item => {
                messg.push('<p>' + item.message + '</p>');
              });
              const logmsg = messg.join(' ');
              this.confirmModalService.show(
                '', 'Error!',
                logmsg,
                '', '', 'OK, Got It', true, ''
              );
            } else {
              this.alertService.error(err.error.message);
            }
          }
        }
      );
    }
  }

  showModal(name: string) {
    this.modalService.setModalSelector(name);
    this.modalService.showModal();
  }

  childClosed() {
    this.modalService.hideModal();
  }
}
